"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
var _typeof = require("@babel/runtime/helpers/typeof");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _react = _interopRequireWildcard(require("react"));
var React = _react;
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != _typeof(e) && "function" != typeof e) return { "default": e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n["default"] = e, t && t.set(e, n), n; }
/**
 * НЕ РЕДАКТИРОВАТЬ
 *
 * Этот файл создан автоматически с помощью svgr
 *
 * Подробнее, как работать с иконками:
 * @see https://lvtv.me/icons
 */
var SvgSpecial = function SvgSpecial(props) {
  return /*#__PURE__*/React.createElement("svg", (0, _extends2["default"])({
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React.createElement("path", {
    d: "m14.674 4.101.151.137.204-.008 3.608-.14.489 3.578.027.202.162.125 2.853 2.212-1.925 3.054-.109.173.044.2.764 3.528-3.438 1.103-.195.063-.095.18-1.683 3.194-3.342-1.365L12 20.26l-.19.077-3.341 1.365-1.683-3.194-.095-.18-.195-.063-3.438-1.103.764-3.528.044-.2-.11-.172-1.924-3.055 2.853-2.212.162-.125.027-.202.49-3.577 3.607.14.204.007.151-.137L12 1.675l2.674 2.426Z",
    fill: "#F8E71C",
    stroke: "#17181A"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#17181A",
    d: "M11.5 7.891h1v6h-1z"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 11.392,
    y: 14.891,
    width: 1.217,
    height: 1.217,
    rx: 0.608,
    fill: "#17181A"
  }));
};
var Memo = /*#__PURE__*/(0, _react.memo)(SvgSpecial);
var _default = exports["default"] = Memo;